import { useEffect, useState } from 'react';

export interface TmtViewportMetrics {
  height: number;
}

// 실제 사용 가능한 viewport 높이를 읽어 게임 영역 높이를 계산한다.
// 브라우저 주소창/탭바 등 UI 변화는 visualViewport.height 로 감지한다.
function computeHeight(): number {
  const visualViewport =
    typeof window !== 'undefined' ? window.visualViewport : undefined;
  return Math.round(
    visualViewport?.height ??
      (typeof window !== 'undefined' ? window.innerHeight : 800),
  );
}

export function useViewportMetrics(): TmtViewportMetrics {
  const [height, setHeight] = useState<number>(() => computeHeight());

  useEffect(() => {
    const visualViewport = window.visualViewport;
    const update = () => setHeight(computeHeight());

    visualViewport?.addEventListener('resize', update);
    visualViewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    return () => {
      visualViewport?.removeEventListener('resize', update);
      visualViewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return { height };
}